export const environments = {
  DEVELOPMENT: "development",
  STAGING: "staging", 
  PRODUCTION: "production",
};

export const environmentEndpoints = {
  [environments.DEVELOPMENT]: "http://localhost:3000",
  [environments.STAGING]: "https://sales-staging.superagi.com",
  [environments.PRODUCTION]: "https://sales.superagi.com",
};

export const getCurrentEnvironment = () => {
  const hostname = window.location.hostname;
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return environments.DEVELOPMENT;
  } else if (hostname.includes('staging')) {
    return environments.STAGING;
  } else {
    return environments.PRODUCTION;
  }
};

export const getCurrentEnvironmentEndpoint = () => {
  return environmentEndpoints[getCurrentEnvironment()];
};

export const notesBaseUrls = {
  [environments.DEVELOPMENT]: "http://notes.superagi.site:3000",
  [environments.STAGING]: "https://notes-staging.superagi.site",
  [environments.PRODUCTION]: "https://notes.superagi.site",
};

export const getNotesBaseUrl = () => notesBaseUrls[getCurrentEnvironment()];
